<template>
  <!-- 案件詳細 -->
  <div id="CpapRequestDetail" v-if="data && data.patient">
    <div id="item-contens">
      <div class="card-content margin-top printMargin printBreakInside" v-if="showRequestInfo && !isTransferCancel">  <!-- QA418 転院から中止に変更する場合、非表示 -->
        <span style="font-size:20px;">案件情報</span>
        <table>
          <!-- QA415 申込み状況、受付番号の表示位置変更 start-->
          <!-- 案件詳細、患者詳細の場合のみ -->
          <template v-if="isShowProject || cancelResume">
            <tr>
              <th>申込み状況</th>
              <td>
                <span :class="getCpapInnerStatusClass(data.status)" style="height:30px;margin-left:5px;width:20%;">
                  {{getCpapProgres(data.status,data.kind)}}
                </span>
              </td>
            </tr>
            <tr v-if="innerUser">
              <th>状態</th>
              <td>
                <span :class="getCpapInnerStatusClass(data.status)" style="height:30px;margin-left:5px;width:20%;">
                  {{getCpapStatus(data.status)}}
                </span>
              </td>
            </tr>
            <tr v-if="!cancelResume">
              <th>受付番号</th>
              <td>{{data.receiptNumber}}</td>
            </tr>
          </template>
          <!-- QA415 申込み状況、受付番号の表示位置変更 end-->
          <tr><th>申込日時</th><td>
            <span>{{data.applicationDate}} {{data.applicationTime}}</span><span style="margin-left:10px;">{{data.applicationUserName}}</span>
          </td></tr>
          <tr v-if="isShowProject
            && data.kind != cpapKindMap.applicationPhilipsCorrespondence
            && data.kind != cpapKindMap.applicationUntreatedMachineReturned
            && data.status != cpapRequestStatus.request
            && data.status != cpapRequestStatus.Approving
            && data.status != cpapRequestStatus.approved">
            <th>確定日時</th>
            <td v-if="data.confirmDate && data.confirmName">
              {{ data.confirmDate }} {{ data.confirmTime }}<span style="margin-left:10px;">{{ data.confirmName }}</span>
            </td>
          </tr>
          <tr v-if="innerUser && !isRequest">
            <th>出荷日</th><td>{{data.shippedDate}}</td>
          </tr>
          <tr v-if="data.completionDate && !isRequest">
            <th>完了日時</th><td><span>{{data.completionDate}} {{data.completionTime}}</span>
          </td></tr>
          <!-- QA415 案件詳細、患者詳細の場合のみ担当情報を追加、受付番号の表示位置変更 start-->
          <tr v-if="innerUser && isShowProject">
            <th>担当情報</th>
            <td style="width:80%;">
                <span style="display:inline-block;width:26%;">
                  {{ data.salesOfficeName }}
                  <span style="margin-left:10px;">{{ data.salesStaffName }}</span>
                </span>
            </td>
          </tr>
          <!-- 案件詳細、患者詳細以外の場合 -->
          <tr v-if="!isShowProject">
            <th>受付番号</th>
            <td>{{data.receiptNumber}}</td>
          </tr>
          <!-- QA415 案件詳細、患者詳細の場合のみ担当情報を追加、受付番号の表示位置変更 end-->

          <!-- QA415 見積情報の表示内容を変更 start-->
          <template v-if="!isHospital && !isDealer && userId">
            <!-- 案件詳細、患者詳細の場合↓ -->
            <template v-if="(isShowProject && data.status != cpapRequestStatus.request) || isPatientDetail">
              <tr style="height:10px;"></tr>
              <template v-for="(items,detailIndex) in data.estimateDetailCode">
                <tr v-if="detailIndex == 0">
                  <th>品目コード</th>
                  <td>
                    <span style="font-weight:bold;color:#363636;">品目名</span>
                    <span style="font-weight:bold;color:#363636;padding-left:24.3%;">見積番号</span>
                    <span style="font-weight:bold;color:#363636;padding-left:12.7%;">見積明細番号</span>
                    <span style="font-weight:bold;color:#363636;padding-left:2%;">オーダーID</span>
                    <span style="font-weight:bold;color:#363636;padding-left:18%;">オーダー明細番号</span>
                  </td>
                </tr>
                <tr :key="detailIndex" v-if="!isViewer">
                  <th style="width:15%;font-weight:normal;color:#061E57;">{{items.itemCode}}</th>
                  <td style="width:80%;">
                    <span style="display:inline-block;width:28%;">{{items.itemName}}</span>
                    <span style="display:inline-block;width:20%;padding-left:1%;">{{items.estimateCode}}</span>
                    <span style="display:inline-block;width:10.5%;">{{items.quotationDetailsNumber}}</span>
                    <span style="display:inline-block;width:10%;padding-left:1%;">
                      {{ items.itemCode === data.model ? data.orderId
                      : items.itemCode === data.moistItemCode ? data.moistOrderId
                      : items.itemCode === data.moduleItemCode ? data.moduleOrderId
                      : "" }}
                    </span>
                    <span style="display:inline-block;width:10%;padding-left:16.5%;">
                      {{ items.itemCode === data.model ? data.orderDetailsNumber
                      : items.itemCode === data.moistItemCode ? data.moistOrderDetailsNumber
                      : items.itemCode === data.moduleItemCode ? data.moduleOrderDetailsNumber
                      : "" }}
                    </span>
                  </td>
                </tr>
                <tr :key="detailIndex" v-else>
                  <th style="width:20%;vertical-align:top;"><span v-if="detailIndex==0">見積明細番号</span></th>
                  <td style="width:80%;">
                    <span style="display:inline-block;width:40%;">{{items.quotationDetailsNumber}}</span>
                    <span style="display:inline-block;width:40%;">{{items.itemCode}}</span>
                    <br><span style="display:inline-block;width:100%;">{{items.itemName}}</span>
                  </td>
                </tr>
              </template>
            </template>
            <!-- 案件詳細、患者詳細以外の場合↓ -->
            <template v-else>
              <tr>
                <th>見積番号</th>
                <td>{{data.estimateCode}}</td>
              </tr>
              <template v-for="(items,detailIndex) in data.estimateDetailCode">
                <tr :key="detailIndex" v-if="!isViewer">
                  <th style="width:15%;"><span v-if="detailIndex==0">見積明細番号</span></th>
                  <td style="width:80%;">
                    <span style="display:inline-block;width:25%;">{{items.quotationDetailsNumber}}</span>
                    <span style="display:inline-block;width:25%;padding-left:1%;">{{items.itemCode}}</span>
                    <span style="display:inline-block;width:38%;padding-left:1%;">{{items.itemName}}</span>
                  </td>
                </tr>
                <tr :key="detailIndex" v-else>
                  <th style="width:20%;vertical-align:top;"><span v-if="detailIndex==0">見積明細番号</span></th>
                  <td style="width:80%;">
                    <span style="display:inline-block;width:40%;">{{items.quotationDetailsNumber}}</span>
                    <span style="display:inline-block;width:40%;">{{items.itemCode}}</span>
                    <br><span style="display:inline-block;width:100%;">{{items.itemName}}</span>
                  </td>
                </tr>
              </template>
            </template>
          </template>
          <!-- QA415 見積情報の表示内容を変更 end-->
          <!-- 案件詳細 転院の場合 -->
          <template v-if="isOutPutProgress(progress,'転院')||isOutPutKind(kind,'転院申込み')">
            <tr>
              <th>転院予定月</th>
              <td>{{convertMonth(data.transferDate)}}</td>
            </tr>
            <tr><th>転院先</th><td>
              <span v-if="data.transferDestinationName">{{data.transferDestinationName}}</span>
              <span v-else>未定</span></td>
            </tr>
            <tr>
              <th style="vertical-align:top;">申送り事項</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.transferMemo}}</td>
            </tr>
          <template v-if="innerUser && data.status==1 && patientDetailsFlag!=false"><!--支店回覧-->
            <tr>
              <th>契約終了日</th>
              <td>{{convertDate(data.contractEndDate)}}</td>
            </tr>
            <tr>
              <th>当月請求<span class="require"/></th>
                <td>
                  <select id="billingCurrentMonth" class="1" name="当月請求" validate="required" v-model="data.billingCurrentMonth">
                    <option v-for="billed in this.billedCurrentMonth" :value="billed.value" :key="billed.value">{{ billed.label }}</option>
                  </select>
                </td>
            </tr>
          </template>
          <template v-else-if="innerUser && (data.status==12 || data.status==14)"><!--受付済み-->
            <tr>
              <th>契約終了日</th>
              <td>{{convertDate(data.contractEndDate)}}</td>
            </tr>
            <tr>
              <th>当月請求</th>
                <td>
                  <span> {{data.billingCurrentMonth | valueToTextFilter(this.billedCurrentMonth)}}</span>
                </td>
            </tr>
          </template>
          <template v-else-if="innerUser"><!--仮受付-->
            <tr>
              <th>契約終了日</th>
              <td><!-- 仮受付のため、内容は空白とする --></td>
            </tr>
            <tr><!-- 仮受付 -->
              <th>当月請求</th>
                <td>
                  <!-- 当月請求欄は残し、内容は空白とする -->
                </td>
            </tr>
          </template>
            <!-- 外部ユーザーの場合、項目「当月請求」は非表示 -->
            <!-- </template> -->
          </template>
          <!-- 案件詳細 転入予定の場合 -->
          <template v-else-if="progress=='5'">
            <tr>
              <th>転院予定月</th>
              <td>{{convertMonth(data.transferDate)}}</td>
            </tr>
            <tr><th>転院先</th><td>
              <span v-if="data.transferDestinationName">{{data.transferDestinationName}}</span>
              <span v-else>未定</span></td>
            </tr>
            <tr>
              <th style="vertical-align:top;">申送り事項</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.transferMemo}}</td>
            </tr>
          <template v-if="innerUser">
            <tr>
              <th>契約終了日</th>
              <td>{{convertDate(data.contractEndDate)}}</td>
            </tr>
            <tr>
              <!-- <th>当月請求<span class="require"/></th> -->
              <th>当月請求</th>
              <td v-if="data.status==14 && patientDetailsFlag==false">
                <span> {{data.billingCurrentMonth | valueToTextFilter(this.billedCurrentMonth)}}</span>
              </td>
            </tr>
          </template>
          </template>
          <!-- QA415 案件詳細、患者詳細以外での申込み状況の表示位置 start-->
          <template v-if="!isShowProject && !cancelResume">
            <tr>
              <th>申込み状況</th>
              <td>
                <span :class="getCpapInnerStatusClass(data.status)" style="height:30px;margin-left:5px;width:20%;">
                  {{getCpapProgres(data.status,data.kind)}}
                </span>
              </td>
            </tr>
            <tr v-if="innerUser">
              <th>状態</th>
              <td>
                <span :class="getCpapInnerStatusClass(data.status)" style="height:30px;margin-left:5px;width:20%;">
                  {{getCpapStatus(data.status)}}
                </span>
              </td>
            </tr>
          </template>
          <!-- QA415 案件詳細、患者詳細以外での申込み状況の表示位置 end-->
          <tr v-if="data.status==15">
            <th style="vertical-align:top;">理由</th>
            <td>
              <textarea maxlength="256" style="resize:vertical;max-width:100%;height:120px" disabled v-model="data.cancelMemo"></textarea>
            </td>
          </tr>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside" v-if="showRequestInfo && (isOutPutProgress(progress,'処方中止')||isOutPutKind(kind,'処方中止'))">
        <table>
          <!-- 案件詳細 処方中止の場合 -->
            <template v-if="cancelEdit">
              <tr v-if="innerUser">
                <!--社内ユーザーのみ表示-->
                <th>契約終了日</th> <!-- QA353 契約終了日をカレンダーからラベルに変更-->
                <td v-if="!isTransferCancel">{{ convertDate(data.contractEndDate) }}</td>
                <td v-else>{{ convertDate(data.contractEndDate) }}<span style="margin-left:30px;">※転院申込み確定日です</span></td> <!--QA418 転院から処方中止に変更の場合 -->
              </tr>
			        <tr v-if="innerUser">
                <!--社内ユーザーのみ表示-->
                <th>当月請求<span class="require"/></th>
                <td>
                  <select id="billingCurrentMonth" class="1" name="当月請求" validate="required" v-model="data.billingCurrentMonth" :disabled="isTransferCancel">
                    <option v-for="billed in this.billedCurrentMonth" :value="billed.value" :key="billed.value">{{ billed.label }}</option>
                  </select>
                </td>
              </tr>
              <tr v-if="innerUser">
                <th>中止理由<span class="require"/></th>
                <td>
                  <select v-model="data.cancelReasonCode" class="1" name="中止理由" validate="required" :disabled="isTransferCancel">
                    <option v-for="cancelCode in this.cancelCodeMaster" :value="cancelCode.value" :key="cancelCode.value">{{ cancelCode.label }}</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th style="vertical-align:top;">中止理由コメント</th>
                <td>
                  <textarea maxlength="255" style="resize:vertical;max-width:100%;height:60px;" v-model="data.cancelReasonText"></textarea>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr v-if="innerUser">
                <!--社内ユーザーのみ表示-->
                <th>契約終了日</th>
                <td>{{convertDate(data.contractEndDate)}}</td>
              </tr>
              <tr v-if="innerUser">
                <!--社内ユーザーのみ表示-->
                <th>当月請求</th>
                <td>{{data.billingCurrentMonth | valueToTextFilter(this.billedCurrentMonth)}}</td>
              </tr>
              <tr v-if="innerUser">
                <th>中止理由</th>
                <td>{{data.cancelReasonCode | valueToTextFilter(this.cancelCodeMaster)}}</td>
              </tr>
              <tr>
                <th style="vertical-align:top;">中止理由コメント</th>
                <td>{{data.cancelReasonText}}</td>
              </tr>
            </template>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside" v-if="showRequestInfo && !isHospital && !isDealer && (isOutPutProgress(progress,'処方中止')||isOutPutKind(kind,'処方中止'))">
        <table>
            <template v-if="cancelEdit">
              <tr>
                <th>回収元<span class="require"/></th>
                <td>
                  <div class="block">
                    <b-radio class="td_radio" name="回収元" v-model="data.collectionDestination" :native-value=0 :disabled="isTransferCancel">支店回収</b-radio>
                    <b-radio class="td_radio" name="回収元" v-model="data.collectionDestination" :native-value=1 :disabled="isTransferCancel">川越回収</b-radio>
                  </div>
                </td>
                <td><span v-if="isTransferCancel" style="font-size:11px; color:red; text-align: left; display: inline-block;">転院申込みから中止申込みに変更した場合は選択できません。</br>必要に応じて支店にて回収してください。</span></td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <!--社内ユーザーのみ表示-->
                <th>回収元</th>
                <td>
                  <span v-if="data.collectionDestination==0">支店回収</span>
                  <span v-if="data.collectionDestination==1">川越回収</span>
                </td>
              </tr>
            </template>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside" v-if="showRequestInfo && (isOutPutProgress(progress,'処方中止')||isOutPutKind(kind,'処方中止'))">
        <table>
            <template v-if="cancelEdit">
              <template>
                <tr>
                  <th>機器回収先<span class="require"/></th>
                  <td>
                    <div class="block">
                      <!-- QA418 転院から処方中止の場合は非活性 -->
                      <b-radio class="td_radio" name="機器回収先" :disabled="isTransferCancel" v-model="data.returnSource" :native-value=0 @input="changeDelivaryTarget(data.returnSource)">患者宅</b-radio>
                      <b-radio class="td_radio" name="機器回収先" :disabled="isTransferCancel" v-model="data.returnSource" :native-value=1 @input="changeDelivaryTarget(data.returnSource)">医療機関</b-radio>
                    </div>
                  </td>
                </tr>
                <!-- QA418 転院から処方中止の場合は非表示 -->
                <tr v-if="!isTransferCancel"><th></th>
                  <td style="vertical-align: middle;"><b-checkbox class="cstmCheckBox" value="true" v-model="data.deliveryOther" @input="changeDelivaryTarget(data.returnSource)">回収先住所を変更する</b-checkbox></td>
                  <td><span style="font-size:11px; color:red; text-align: left; display: inline-block;">※チェックをした場合、こちらの住所は得意先コードの住所（患者・医療機関）には反映されません。</br>※支店・営業所の住所は入力しないでください。</span></td>
                </tr>
              </template>
              <template v-if="!data.deliveryOther">
              <tr>
                <th>郵便番号<span class="require"/></th>
                <td colspan="2">
                  <input
                    id="deliveryPostcode"
                    style="width: 270px;"
                    v-model="data.deliveryPostcode"
                    class="1"
                    name="郵便番号"
                    validate="required|numeric"
                    maxlength="7"
                    disabled
                    :placeholder="postcodePlaceholder"
                  />
                </td>
              </tr>
              <tr><th>住所（都道府県、市町村区）<span class="require" style="margin-left:-8px;"/></th><td colspan="2"><input type="text" v-model="data.deliveryAddress" class="1" name="住所（都道府県、市町村区）" validate="required" maxlength="280" disabled/></td></tr>
              <tr><th>住所（それ以降の住所）<span class="require"/></th><td colspan="2"><input type="text" v-model="data.deliveryHouseNumber" class="1" name="住所（それ以降の住所）" validate="required" maxlength="256" disabled/></td></tr>
              <tr><th>住所（建物名、部屋番号）</th><td colspan="2"><input type="text" v-model="data.deliveryBuilding" maxlength="256" disabled/></td></tr>
              <tr><th>回収先名称<span class="require"/></th><td colspan="2"><input type="text" v-model="data.deliveryDestination" maxlength="100" class="1" name="回収先名称" validate="required" disabled/></td></tr>
              <tr>
                <th>連絡先（電話番号）<span class="require"/></th>
                <td colspan="2">
                  <input
                    type="text"
                    v-model="data.deliveryPhoneNumber"
                    maxlength="11"
                    class="1"
                    name="連絡先（電話番号）"
                    validate="required|numeric"
                    disabled
                    :placeholder="phonePlaceholder"
                  />
                </td>
              </tr>
              </template>
              <template v-else>
                <tr>
                  <th>
                    郵便番号<span class="require"/>
                  </th>
                  <td colspan="2">
                    <input
                      id="deliveryPostcode"
                      style="width: 270px;"
                      v-model="data.deliveryPostcode"
                      class="1"
                      :class="{'border-red': invalidPostcode}"
                      name="郵便番号"
                      validate="required|numeric|zip"
                      maxlength="7"
                      :placeholder="postcodePlaceholder"
                      @paste="onPaste"
                      @blur="onZipBlur(data.deliveryPostcode, 'digitErrorDeliveryPostcode')"/>
                    <b-button
                      style="margin-left: 10px; width: 150px; height: 27px;"
                      v-on:click="addressSearch(data.deliveryPostcode)"
                    >
                      自動入力
                    </b-button>
                    <div v-show="invalidPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                    <div v-show="digitErrorDeliveryPostcode" class="text-red">{{ digitErrorZipMessage }}</div>
                  </td>
                </tr>
                <tr><th>住所（都道府県、市町村区）<span class="require" style="margin-left:-8px;"/></th><td colspan="2"><input type="text" v-model="data.deliveryAddress" class="1" name="住所（都道府県、市町村区）" validate="required" maxlength="280"/></td></tr>
                <tr><th>住所（それ以降の住所）<span class="require"/></th><td colspan="2"><input type="text" v-model="data.deliveryHouseNumber" class="1" name="住所（それ以降の住所）" validate="required" maxlength="256" ref="deliveryHouseNumber"/></td></tr>
                <tr><th>住所（建物名、部屋番号）</th><td colspan="2"><input type="text" v-model="data.deliveryBuilding" maxlength="256"/></td></tr>
                <tr><th>回収先名称<span class="require"/></th><td colspan="2"><input type="text" v-model="data.deliveryDestination" maxlength="100" class="1" name="回収先名称" validate="required"/></td></tr>
                <tr>
                  <th>
                    連絡先（電話番号）<span class="require"/>
                  </th>
                  <td colspan="2">
                    <input
                      type="text"
                      v-model="data.deliveryPhoneNumber"
                      maxlength="11"
                      class="1"
                      :class="{'border-red': invalidPhoneNumber}"
                      name="連絡先（電話番号）"
                      validate="required|numeric"
                      :placeholder="phonePlaceholder"
                    />
                    <div v-show="invalidPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                  </td>
                </tr>
              </template>
            </template>
            <template v-else>
              <tr>
                <th>機器回収先</th>
                <td>
                  <span v-if="data.returnSource==0">患者宅</span>
                  <span v-if="data.returnSource==1">医療機関</span>
                </td>
              </tr>
              <tr><th></th><td><b-checkbox style="width: 26px;" v-model="data.deliveryOther" disabled></b-checkbox>お届け先住所を変更する</td></tr>
              <tr>
                <th>郵便番号</th>
                <td>{{data.deliveryPostcode}}</td>
              </tr>
              <tr>
                <th>住所（都道府県、市町村区）</th>
                <td>{{data.deliveryAddress}}</td>
                </tr>
              <tr>
                <th>住所（それ以降の住所）</th>
                <td>{{data.deliveryHouseNumber}}</td>
              </tr>
              <tr>
                <th>住所（建物名、部屋番号）</th>
                <td>{{data.deliveryBuilding}}</td>
              </tr>
              <tr>
                <th>回収先名称</th>
                <td>{{data.deliveryDestination}}</td>
              </tr>
              <tr>
                <th>連絡先（電話番号）</th>
                <td>{{data.deliveryPhoneNumber}}</td>
              </tr>
            </template>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside" v-if="innerUser && resume && data.beforeItems && data.beforeItems.length > 0">
        <span style="font-size:20px;">転院前使用品目</span>
        <table>
          <tr>
            <th style="width:20%;">品目コード</th>
            <th style="width:30%;">品目名</th>
            <!-- <th style="width:25%;">見積詳細番号</th> -->
          </tr>
          <template v-for="(beforeItem,beforeItemIndex) in data.beforeItems">
            <tr :key="beforeItemIndex">
              <td>
                <span v-if="beforeItem.itemCode">{{beforeItem.itemCode}}</span>
                <span v-else style="color:red;">指示書未選択</span>
              </td>
              <td>{{beforeItem.itemName}}</td>
              <!-- <td>
                <span v-if="beforeItem.quotationDetailsNumber">{{beforeItem.quotationDetailsNumber}}</span>
                <span v-else style="color:red;">見積未選択</span>
              </td> -->
            </tr>
          </template>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside" v-if="innerUser && directionsItemList && directionsItemList.length > 0">
        <span style="font-size:20px;">品目情報</span>
        <table>
          <tr>
            <th style="width:20%;">品目コード</th>
            <th style="width:50%;">品目名</th>
            <!-- <th style="width:30%;">見積詳細番号</th> -->
          </tr>
          <template v-for="(directionsItem,directionsItemIndex) in directionsItemList">
            <tr :key="directionsItemIndex">
              <td style="width:20%;">
                <span v-if="directionsItem.itemCode">{{directionsItem.itemCode}}</span>
                <span v-else style="color:red;">指示書未選択</span>
              </td>
              <td style="width:50%;">{{directionsItem.name}}</td>
              <!-- <td style="width:30%;">
                <span v-if="directionsItem.quotationDetailsNumber">選択済み</span>
                <span v-else style="color:red;">見積未選択</span>
              </td> -->
            </tr>
          </template>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">医療機関情報</span>
        <table>
          <tr><th>指示日</th><td id="editMark"></td><td>{{convertDate(data.instructionDate)}}</td></tr>
          <!-- <template v-if="data.depositUseFlag"> -->
          <!-- 外部ユーザーでは非表示20240329 -->
          <template v-if="data.depositUseFlag && innerUser">
            <tr>
              <th>契約終了日</th><td id="editMark"></td>
              <td>{{convertDate(data.depositContractEndDate)}}</td>
            </tr>
            <tr>
              <th>当月請求</th><td id="editMark"></td>
              <td>{{data.depositBillingCurrentMonth | valueToTextFilter(this.billedCurrentMonth)}}</td>
            </tr>
            <tr>
              <th>契約取消理由</th><td id="editMark"></td>
              <td>{{data.depositCancelReasonCode | valueToTextFilter(this.cancelCodeMaster)}}</td>
            </tr>
          </template>
          <!-- QA415 ユーザーが医療機関、ディーラー以外の場合、組織ID追加 start-->
          <tr v-if="!isHospital && !isDealer && !viewerFlg">
            <th>組織ID</th>
            <td></td>
            <td>{{ data.belongsId }}</td>
          </tr>
          <!-- QA415 ユーザーが医療機関、ディーラー以外の場合、組織ID追加 end-->
          <tr><th>{{ isDealer || !userId ? "申請元医療機関名" : "医療機関名" }}</th><td id="editMark"></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.medicalInstitutionName}}</td></tr>
          <tr><th>医師名</th><td id="editMark"><span v-if="changedCheck('doctorName','doctorName',false)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.doctorName}}</td></tr>
          <tr><th>事務担当者名</th><td id="editMark"><span v-if="changedCheck('clerkName','clerkName',false)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.clerkName}}</td></tr>
          <tr v-if="innerUser && commentFlg"><th>コメント</th><td></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.note}}</td></tr>
          <template v-if="data.isDealer">
            <tr><th>医療機関メールアドレス</th><td id="editMark"><span v-if="changedCheck('mailNotification','mailNotification',false)" class="change"></span></td><td><b-checkbox style="width: 26px" value="true" disabled v-model="data.mailNotification"></b-checkbox>申込み内容を医療機関にメールで通知する。</td></tr>
            <tr v-if="data.mailNotification"><th></th><td>{{data.hospitalMail}}</td></tr>
          </template>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">患者情報</span>
        <table>
          <tr v-if="data.patientCode"><th>患者コード</th><td id="editMark"><span v-if="changedCheck('patientCode','patientCode',false)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patientCode}}</td></tr>
          <tr><th>診察券ID（患者ID）</th><td id="editMark"><span v-if="changedCheck('patientRegistrationCard','patientRegistrationCard',true)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patient.patientRegistrationCard}}</td></tr>
          <tr><th>患者名</th><td id="editMark"><span v-if="changedCheck('patientName','patientName',false)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patient.patientFamilyName}} {{data.patient.patientFirstName}}</td></tr>
          <tr><th>患者名（カナ）</th><td id="editMark"><span v-if="changedCheck('patientNameKana','patientNameKana',false)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patient.patientFamilyNameKana}} {{data.patient.patientFirstNameKana}}</td></tr>
          <tr><th>性別</th><td id="editMark"><span v-if="changedCheck('gender','gender',true)" class="change"></span></td><td>{{data.patient.gender}}</td></tr>
          <tr><th>生年月日</th><td id="editMark"><span v-if="changedCheck('birthday','birthday',false)" class="change"></span></td><td>{{convertDate(data.patient.birthday)}}<span v-if="data.patient.birthday" style="margin-left:10px;">{{data.patient.japaneseCalendar}}</span></td></tr>
          <tr><th>年齢</th><td id="editMark"></td><td>{{data.patient.age}}</td></tr>
          <tr><th>郵便番号</th><td id="editMark"><span v-if="changedCheck('patientPostcode','zip',true)" class="change"></span></td><td>{{data.patient.zip}}</td></tr>
          <tr><th>住所（都道府県、市町村区）</th><td id="editMark"><span v-if="changedCheck('patientAddress','address',true)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patient.address}}</td></tr>
          <tr><th>住所（それ以降の住所）</th><td id="editMark"><span v-if="changedCheck('patientHouseNumber','address1',true)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patient.address1}}</td></tr>
          <tr><th>住所（建物名、部屋番号）</th><td id="editMark"><span v-if="changedCheck('patientBuilding','address2',true)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patient.address2}}</td></tr>
          <tr><th>連絡先（携帯電話）</th><td id="editMark"><span v-if="changedCheck('patientMobilePhone','mobilePhone',true)" class="change"></span></td><td>{{data.patient.mobilePhone}}</td></tr>
          <tr><th>連絡（自宅・その他）</th><td id="editMark"><span v-if="changedCheck('patientPhoneNumber','phoneNumber',true)" class="change"></span></td><td>{{data.patient.phoneNumber}}</td></tr>
          <tr v-if="(data.kind == cpapKindMap.application || data.kind == cpapKindMap.applicationDepositMachine || data.kind == cpapKindMap.applicationTempRemoval) && !cancelResume"><th>フォローアップコール</th><td id="editMark"><span v-if="changedCheck('followUpCall','followUpCall',true)" class="change"></span></td><td><span v-if="data.patient.followUpCall">する</span><span v-else>しない</span></td></tr>
          <tr><th>病名</th><td id="editMark"><span v-if="changedCheck('disease','disease',true)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patient.disease}}</td></tr>
          <tr><th>感染症</th><td id="editMark"><span v-if="changedCheck('infection','infection',true)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patient.infection | infectionFilter()}}</td></tr>
          <tr><th>感染症名(その他)</th><td id="editMark"><span v-if="changedCheck('infectionText','infectionName',true)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patient.infectionName}}</td></tr>
          <tr><th>地域医療連携施設名</th><td id="editMark"><span v-if="changedCheck('communityMedicineName','hospitalName',true)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patient.hospitalName}}</td></tr>
          <tr><th>地域医療連携施設　医師名</th><td id="editMark"><span v-if="changedCheck('communityMedicineDoctorName','doctorName',true)" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patient.doctorName}}</td></tr>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">装置情報</span>
        <table>
          <tr><th>機種</th><td id="editMark"><span v-if="changedCheck('reportFormatType','reportFormatType',false)" class="change"></span></td><td>{{data.model | getNameFilter(models)}}</td></tr>
          <tr><th>シリアル</th><td id="editMark"><span v-if="changedCheck('serial','serial',false)" class="change"></span></td><td>{{data.serial}}</td></tr>
          <!-- <tr><th>使用機器</th><td><b-checkbox class="cstmCheckBox" v-model="data.depositUseFlag" disabled>預託機を使用する（要預託契約）</b-checkbox></td></tr> -->
          <!-- 処方変更の場合 設定変更対応欄不要20231225-->
          <!-- <tr v-if="data.kind == cpapKindMap.applicationChange"><th>設定変更対応</th>
            <td id="editMark"><span v-if="changedCheck('settingChanger',data.settingChanger)" class="change"></span></td>
            <td v-if="data.settingChanger==0">医療機関にて対応済</td>
            <td v-if="data.settingChanger==1">Philipsへ対応依頼</td>
          </tr> -->
        </table>
      </div>
      <!-- 印刷用フッター -->
      <div class="printTarget print_footer" style="display:none;">
        （診察券ID）{{data.patient.patientRegistrationCard}}／（患者名）{{data.patient.patientFamilyName}} {{data.patient.patientFirstName}}
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <div style="display: flex;align-items: center;"><span style="flex: 1;text-align: right;"><span v-if="changedCheck('reportFormatType','reportFormatType',false)" class="change"></span></span><span style="font-size:20px;">設定情報</span><span style="flex: 1;"></span></div>
        <div style="display: flex;">
          <table class="settings">
            <template v-for="(content, index) in data.prescriptionItems.filter(val=>{ return val.category===0})">
              <tr v-if="content.type==='char' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th><td id="editMark"><span v-if="changedPrescriptionCheck(content.displayOrder,content.displayName)" class="change"></span></td>
                <td>{{content.value}}<span v-if="content.value">{{content.unit}}</span></td>
              </tr>
              <tr v-if="content.type==='sel' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th><td id="editMark"><span v-if="changedPrescriptionCheck(content.displayOrder,content.displayName)" class="change"></span></td>
                <td>{{content.value | getSelectValueFilter(content.displayValue)}}<span v-if="content.value">{{content.unit}}</span></td>
              </tr>
              <tr v-if="content.type==='calender' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th><td id="editMark"><span v-if="changedPrescriptionCheck(content.displayOrder,content.displayName)" class="change"></span></td>
                <td>{{content.value | getCalenderValueFilter()}}</td>
              </tr>
              <tr v-if="content.type==='radio' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th><td id="editMark"><span v-if="changedPrescriptionCheck(content.displayOrder,content.displayName)" class="change"></span></td>
                <td>{{content.value | getSelectValueFilter(content.displayValue)}}</td>
              </tr>
            </template>
          </table>
        </div>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">加温加湿器</span>
        <div style="display: flex;">
          <table class="settings">
            <template v-for="(content, index) in data.prescriptionItems.filter(val=>{ return val.category===1})">
              <tr v-if="content.type==='char' && data.useMoist && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th><td id="editMark"><span v-if="moistPrescriptionCheck(content.displayName)" class="change"></span></td>
                <td>{{content.value}}{{content.unit}}</td>
              </tr>
              <tr v-if="content.type=== 'sel' && data.useMoist && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th><td id="editMark"><span v-if="moistPrescriptionCheck(content.displayName)" class="change"></span></td>
                <td>{{content.value | getSelectValueFilter(content.displayValue)}}{{content.unit}}</td>
              </tr>
              <!-- QA421_加湿器、モデムの設置日の項目を削除する -->
              <!-- <tr v-if="content.type=== 'calender' && data.useMoist && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th><td id="editMark"><span v-if="changedPrescriptionCheck(content.displayName) || hardwareCheck() || addCheck('moistarea')" class="change"></span></td>
                <td>{{content.value | getCalenderValueFilter()}}</td>
              </tr> -->
              <tr v-if="content.type==='radio' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th><td id="editMark"><span v-if="moistPrescriptionCheck(content.displayName)" class="change"></span></td>
                <td>{{content.value | getSelectValueFilter(content.displayValue)}}</td>
              </tr>
            </template>
            <tr v-if="data.useMoist"><th>品目コード</th><td id="editMark"><span v-if="moduleMoistCheck('moistArea','moistItemCode')" class="change"></span></td><td>{{data.moistItemCode}}</td></tr>
            <tr v-if="data.useMoist"><th>シリアル</th><td id="editMark"><span  v-if="moduleMoistCheck('moistArea','moistSerial')" class="change"></span></td><td>{{data.moistSerial}}</td></tr>
          </table>
        </div>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">通信モジュール</span>
        <div style="display: flex;">
          <table class="settings">
            <template v-for="(content, index) in data.prescriptionItems.filter(val=>{ return val.category===2})">
              <tr v-if="content.type==='char' && data.useModule && !isHideItem(content.displayName) && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th><td id="editMark"><span v-if="modulePrescriptionCheck(content.displayName)" class="change"></span></td>
                <td>{{content.value}}{{content.unit}}</td>
              </tr>
              <tr v-if="content.type=== 'sel' && data.useModule && !isHideItem(content.displayName) && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th><td id="editMark"><span v-if="modulePrescriptionCheck(content.displayName)" class="change"></span></td>
                <td>{{content.value | getSelectValueFilter(content.displayValue)}}{{content.unit}}</td>
              </tr>
              <!-- QA421_加湿器、モデムの設置日の項目を削除する -->
              <!-- <tr v-if="content.type=== 'calender' && data.useModule && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th><td id="editMark"><span v-if="changedPrescriptionCheck(content.displayName) || hardwareCheck() || addCheck('modulearea') || modulchangedCheck()" class="change"></span></td>
                <td>{{content.value | getCalenderValueFilter()}}</td>
              </tr> -->
              <tr v-if="content.type==='radio' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th><td id="editMark"><span v-if="modulePrescriptionCheck(content.displayName)" class="change"></span></td>
                <td>{{content.value | getSelectValueFilter(content.displayValue)}}</td>
              </tr>
            </template>
            <tr v-if="data.useModule"><th>品目コード</th><td id="editMark"><span v-if="moduleMoistCheck('moduleArea','moduleItemCode')" class="change"></span></td><td>{{data.moduleItemCode}}</td></tr>
            <!-- <tr v-if="data.useModule"><th>シリアル</th><td id="editMark"><span v-if="changedCheck('moduleSerial',data.moduleSerial) || hardwareCheck() || addCheck('modulearea') || modulchangedCheck()" class="change "></span></td><td>{{data.moduleSerial}}</td></tr> -->
            <tr v-if="data.useModule && this.data.reportFormatType != 3"><th>シリアル</th><td id="editMark"><span v-if="moduleMoistCheck('moduleArea','moduleSerial')" class="change "></span></td><td>{{data.moduleSerial}}</td></tr>
          </table>
        </div>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">マスク</span>
        <div style="display: flex;">
          <table class="settings">
            <tr>
              <th style="white-space:pre-wrap;width:250px;">マスク：種類</th>
              <td id="editMark"><span v-if="changedCheck('maskType','maskType',false)" class="change"></span></td>
              <td>{{data.maskType}}</td>
            </tr>
            <tr>
              <th style="white-space:pre-wrap;width:250px;">マスク：クッションサイズ</th>
              <td id="editMark"><span v-if="changedCheck('cushionSize','cushionSize',false)" class="change"></span></td>
              <td>{{data.cushionSize}}</td>
            </tr>
            <tr>
              <th style="white-space:pre-wrap;width:250px;">マスク：フレームサイズ</th>
              <td id="editMark"><span v-if="changedCheck('frameSize','frameSize',false)" class="change"></span></td>
              <td>{{data.frameSize}}</td>
            </tr>
            <tr>
              <th style="white-space:pre-wrap;width:250px;">マスク：固定方法</th>
              <td id="editMark"><span v-if="changedCheck('fixingMethod','fixingMethod',false)" class="change"></span></td>
              <td>{{data.fixingMethod}}</td>
            </tr>
            <tr v-if="innerUser">
              <th style="white-space:pre-wrap;width:250px;">ロット番号</th>
              <td id="editMark"><span v-if="changedCheck('lot','lot',false)" class="change"></span></td>
              <td>{{data.lot}}</td>
            </tr>
            <tr v-if="data.maskType=='その他'">
              <th style="white-space:pre-wrap;width:250px;">備考</th>
              <td id="editMark"></td>
              <td>オーダー情報の備考欄を参照してください。</td>
            </tr>
          </table>
        </div>
      </div>
      <!-- 印刷用フッター -->
      <div class="printTarget print_footer" style="display:none;">
        （診察券ID）{{data.patient.patientRegistrationCard}}／（患者名）{{data.patient.patientFamilyName}} {{data.patient.patientFirstName}}
      </div>
      <div class="card-content margin-top printMargin printBreakInside pageBreakBefore" v-if="!isDeliveryInfoHidden&&!isOutPutProgress(progress,'処方中止')&&!isOutPutKind(kind,'処方中止')&&!resume&&data.kind!=4&&!data.notDirections&&!data.depositUseFlag">
        <span style="font-size:20px;">納品先情報</span>
        <table>
          <!-- 医療機関発送の場合 -->
          <tr><th>機器納品先</th>
            <td v-if="data.delivaryTarget=='hospital'">医療機関</td>
            <td v-else-if="data.delivaryTarget=='home'">患者宅</td></tr>
          <tr><th></th><td><b-checkbox style="width: 26px;" v-model="data.deliveryOther" disabled></b-checkbox>お届け先住所を変更する</td></tr>
          <tr><th>郵便番号</th><td>{{data.deliveryPostcode}}</td></tr>
          <tr><th>住所（都道府県、市町村区）</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.deliveryAddress}}</td></tr>
          <tr><th>住所（それ以降の住所）</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.deliveryHouseNumber}}</td></tr>
          <tr><th>住所（建物名、部屋番号）</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.deliveryBuilding}}</td></tr>
          <tr><th>納品先宛名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.deliveryDestination}}</td></tr>
          <tr><th>連絡先（電話番号）</th><td>{{data.deliveryPhoneNumber}}</td></tr>
          <template v-if="innerUser">
            <tr>
              <th style="vertical-align:top;">納品書コメント1</th>
              <td>{{data.deliveryStatementComment1}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">納品書コメント2</th>
              <td>{{data.deliveryStatementComment2}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">発送元</th>
              <td>{{data.senderType | codeToValueFilter(cpapSenderMaster)}}</td>
            </tr>
            <tr v-if="isSendBranch()">
              <th style="vertical-align:top;">発送方法</th>
              <td>{{data.shippingMethod | codeToValueFilter(cpapShippingMethodList)}}</td>
            </tr>
          </template>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside" v-if="innerUser && isRequest && isSendBranch()">
        <span style="font-size:20px;">配達情報</span>
        <table>
          <tr style="text-align:top;">
            <th style="vertical-align:top;">出荷日</th>
            <td>{{convertDate(data.shippingDate)}}</td>
          </tr>
        </table>
      </div>
      <!-- 
          <tr>
            <th>配達指定日の有無</th>
            <td><span v-if="data.isAppointedDelivery=='0'">配達指定日なし</span><span v-if="data.isAppointedDelivery=='1'">配達指定日あり</span></td>
          </tr>
          <tr v-if="data.isAppointedDelivery=='1'">
            <th style="vertical-align:top;">配達指定日</th>
            <td>{{convertDate(data.appointedDeliveryDate)}}</td>
          </tr>
          <tr v-if="data.isAppointedDelivery=='1'">
            <th style="vertical-align:top;">配達時間帯</th>
            <td>{{data.appointedDeliveryPeriodOfTime | valueToTextFilter(deliveryTimeZone)}}</td>
          </tr>
          <tr>
            <th style="vertical-align:top;">指定納期</th>
            <td>{{convertDate(data.specifiedDeliveryDate)}}</td>
          </tr>
      -->
      <!-- 社内ユーザーかつ、処方変更(返却あり)の場合 -->
      <div class="card-content margin-top" v-if="innerUser && data.kind==cpapKindMap.applicationChange && data.machineReturn">
        <span style="font-size:20px;">返却情報</span>
        <table>
          <tr>
            <th>回収先</th>
            <td>
              <span v-if="data.collectionDestination==0">支店回収</span>
              <span v-if="data.collectionDestination==1">川越回収</span>
            </td>
          </tr>
          <tr>
            <th>契約終了日</th>
            <td>{{convertDate(data.contractEndDate)}}</td>
          </tr>
          <tr>
            <th>当月請求</th>
            <td>{{data.billingCurrentMonth | valueToTextFilter(this.billedCurrentMonth)}}</td>
          </tr>
          <tr>
            <th>中止理由</th>
            <td>{{data.cancelReasonCode | valueToTextFilter(this.cancelCodeMaster)}}</td>
          </tr>
          <tr>
            <th style="vertical-align:top;">中止理由コメント</th>
            <td>{{data.cancelReasonText}}</td>
          </tr>
        </table>
      </div>

      <div class="card-content margin-top" v-if="showRequestMemo">
        <span style="font-size:20px;">オーダー情報</span>
        <table>
          <template v-if="innerUser && !isRequest">
            <tr>
              <th style="vertical-align:top;">請求開始日</th>
              <td id="editMark"></td>
              <td>{{convertDate(data.billingStartDate)}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">請求書コメント</th>
              <td id="editMark"></td>
              <td>{{data.billComment}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">診療科コード</th>
              <td id="editMark"><span v-if="changedCheck('departmentCode','departmentCode',false)" class="change"></span></td>
              <td>{{data.departmentCode | valueToTextFilter(this.departmentMaster)}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">得意先区分</th>
              <td id="editMark"><span v-if="changedCheck('customerClass','customerClass',false)" class="change"></span></td>
              <td>{{data.customerClass | valueToTextFilter(this.customerCategory)}}</td>
            </tr>
            <!-- <tr v-if="innerUser && resume"> QA504 前回消耗品供給日を削除
              <th style="vertical-align:top;">前回消耗品供給日</th>
              <td><span></span></td>
              <td>{{convertDate(data.accessoryLastSupplyDate)}}</td>
            </tr> -->
            <tr v-if="data.kind == cpapKindMap.application || data.kind == cpapKindMap.applicationResume || data.kind == cpapKindMap.applicationTempRemoval">
              <th style="vertical-align:top;">直送先種別</th>
              <td id="editMark"></td>
              <td>{{data.directShippingType | codeToValueFilter(cpapDirectShippingList)}}</td>
            </tr>
            <tr v-if="data.kind == cpapKindMap.application || data.kind == cpapKindMap.applicationResume || data.kind == cpapKindMap.applicationTempRemoval">
              <th style="vertical-align:top;">リースアップ種別</th>
              <td id="editMark"></td>
              <td>{{data.leaseUpType | codeToValueFilter(cpapLeaseUpList)}}</td>
            </tr>
            <!-- webシステムより不要との回答あり
            <tr>
              <th style="vertical-align:top;">戦略施策</th>
              <td>{{data.strategicMeasures | valueToTextFilter(strategicMeasures)}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">戦略施策コメント</th>
              <td>{{data.strategicMeasuresComment}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">予備</th>
              <td>{{data.reserve | valueToTextFilter(reserve)}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">予備コメント</th>
              <td>{{data.reserveComment}}</td>
            </tr> -->
          </template>
          <tr>
            <th style="vertical-align:top;">備考</th>
            <td id="editMark"><span v-if="changedCheck('remarks','memo',false)" class="change"></span></td>
            <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.memo}}</td>
          </tr>
        </table>
      </div>
      <!-- 印刷用フッター -->
      <div class="printTarget print_footer" style="display:none;">
        （診察券ID）{{data.patient.patientRegistrationCard}}／（患者名）{{data.patient.patientFamilyName}} {{data.patient.patientFirstName}}
      </div>
    </div>
    <b-modal :active.sync="organizationModalActive" has-modal-card>
      <organizationSelectModal :selectRole="[role.role_hospital]" :selectStatus="extUserStatus.registed" title="医療機関選択" labelForOrg="医療機関名" @select="setHospital" :exclusionId="data.belongsId" :agreedInfoDisclosure="isHospital || isDealer"></organizationSelectModal>
    </b-modal>
  </div>
</template>
<script>
import {
  role,
  extUserStatus,
  cpapShippingMethodList,
  cpapSenderMaster,
  cpapKindMap,
  cpapDirectShippingList,
  cpapLeaseUpList,
  invalidNumberMessage,
  postcodePlaceholder,
  phonePlaceholder,
  cpapChoicesType,
  cpapRequestStatus,
  digitErrorZipMessage,
} from "@/components/mock/base/const.js";
import OrganizationSelectModal from "@/components/mock/philips/common/OrganizationSelectModal";

export default {
  name: "CpapRequestDetail",
  props: {
    data:null,
    showRequestInfo:{default:false},
    showRequestMemo:{default:true},
    innerUser:{},
    progress:"",
    patientDetailsFlag:{},
    kind:"",
    isEdit:null,
    isMasterAcquisition:true,
    cancelEdit:{default:false},
    deliveryHidden:{default:false},
    requestFlg:{default:false},
    directionsItem:{default:() => ([])},
    isResume:{default:false},
    viewerFlg:{default:false},
    commentFlg:{default:false},
    cancelResume:{default:false},
    isShowProject:{default:false},
    isPatientDetail:{default:false},
    isTransferCancel:{default:false},
  },
  methods: {
    isHideItem: function(displayName) {
      if(displayName == "登録方法"){
        var patientManagement = this.data.prescriptionItems.find(val => val.displayName == "患者情報管理")
        if(patientManagement && patientManagement.value=='0'){
          return true
        }
      }
      if(displayName == "E-mailアドレス"){
        var mobileApply = this.data.prescriptionItems.find(val => val.displayName == "モバイルアプリ")
        if(mobileApply && mobileApply.value=='0'){
          return true
        }
      }
      return false
    },
    // getDepositoryCodeMaster: function() {
    //   this.depositoryCodeMaster = []
    //   if(!this.officeCode) return
    //   // Web Api Call
    //   var _this = this;
    //   this.apiCall(
    //     function(client){
    //       return client.apis.apiCommon.getCpapStorageLocationPOST({
    //         body:{
    //           salesOfficeCode: "J"+_this.officeCode
    //         }
    //       });
    //     },
    //     async function(result){
    //       _this.depositoryCodeMaster = result.obj;
    //     },
    //     function(result){
    //       _this.showErrorMessage(result);
    //     }
    //   );
    // },
    isSendBranch: function() {
      if(!this.data.senderType) return false
      var target = this.cpapSenderMaster.find(val => val.code == this.data.senderType)
      if(target && target.name.indexOf("支店") != -1){
        // 支店発送の場合
        return true
      }
      return false
    },
    convertDate: function(day){
      return day ? day.replace(/-/g, "/") : ""
    },
    convertMonth: function(month){
      if(!month) return ""
      var y = month.split("-")[0];
      var m = month.split("-")[1];
      return y + "/" + m
    },
    isEditStatus: function(status,targetName){
      var statusName = this.getCpapStatus(status)
      return statusName == targetName
    },
    isOutPutProgress: function(code,targetValue) {
      var flg = false
      var target = this.progressList.find(val => val.code == code)
      if(target && target.name.indexOf(targetValue) != -1){
        flg = true
      }
      return flg
    },
    isOutPutKind: function(code,targetValue) {
      var flg = false
      var target = this.kindList.find(val => val.code == code)
      if(target && target.name.indexOf(targetValue) != -1){
        flg = true
      }
      return flg
    },
    setHospital: function(hospitalInfo){
      this.data.transferDestinationId = hospitalInfo.id
      this.data.transferDestinationCode = hospitalInfo.customerCode
      this.data.transferDestinationName = hospitalInfo.orgName
    },
    hospitalDecision: function(){
      // 転院先設定
      var excuteApi = this.setCpapTransferDestinationPOST;
      var successCallBack = this.setCpapTransferDestinationPOSTSuccess;
      var errorCallBack = this.setCpapTransferDestinationPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setCpapTransferDestinationPOST: function(client) {
      return client.apis.externalCpap.setCpapTransferDestinationPOST({
        body:{
          receiptNumber:this.data.receiptNumber,
          transferDate:this.data.transferDate ? this.data.transferDate.replace(/-/g, "/") :"",
          transferDestinationId:this.data.transferDestinationId,
          transferDestinationCode:this.data.transferDestinationCode,
          transferDestinationName:this.data.transferDestinationName,
          transferMemo:this.data.transferMemo
        }
      });
    },
    setCpapTransferDestinationPOSTSuccess: function(result) {
      this.showSuccess(result);
      this.$emit("back");
    },
    setCpapTransferDestinationPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    addressSearch: function(val){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val
      this.searchTargetAddress = null
      this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return;
        this.data.deliveryAddress = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
        this.data.deliveryHouseNumber = "";
        this.data.deliveryBuilding = "";

        // QA476 住所設定後フォーカスを移動する
        this.focusMove("deliveryHouseNumber");
        this.digitErrorDeliveryPostcode = false;
      })
    },
    postCodeSearch: function(){
      var excuteApi = this.getAddressFromPostCodePOST;
      var successCallBack = this.getAddressFromPostCodePOSTSuccess;
      var errorCallBack = this.getAddressFromPostCodePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAddressFromPostCodePOST: function(client) {
      return client.apis.apiCommon.getAddressFromPostCodePOST({
        body:{
          postCode:this.searchTargetPostCode
        }
      });
    },
    getAddressFromPostCodePOSTSuccess: function(result) {
      this.searchTargetAddress = result.obj
      this.searchTargetPostCode = ""
    },
    getAddressFromPostCodePOSTError: function(result) {
      this.searchTargetPostCode = ""
    },
    changedCheck: function(itemName,key,patientFlag) {
      // QA358_変更ありマークの改修（カラム値の比較）
      // 処方変更・転院再開・中止再開・内部指示書連携にのみ表示
      if (!this.isRequest) {
        if (this.data.kind == this.cpapKindMap.applicationChange || this.data.kind == this.cpapKindMap.applicationResume || this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence) {
          if (this.data.previousRequestCpap) {
            let target = patientFlag ? this.data.patient[key] : this.data[key]
            let oldtarget = this.data.previousRequestCpap[itemName]
            // 機器納品先の比較値成形
            if (itemName == 'sendMedicalInstitutionFlag') {
              target = target == 'hospital' ? true : false
            // 患者名&納品先宛名の比較値成形
            } else if (itemName == 'patientName' || itemName == 'patientNameKana' || itemName == 'deliveryDestination') {
              target = target ? target.replace(/ /g, '').replace(/　/g, '').replace(/\t/g, '').replace(/(\r)*\n/g, '').replace(/\r/g, '') : target
              oldtarget = oldtarget ? oldtarget.replace(/ /g, '').replace(/　/g, '').replace(/\t/g, '').replace(/(\r)*\n/g, '').replace(/\r/g, '') : oldtarget
            // 電話番号＆機器納品先電話番号の比較値成形
            } else if (itemName == 'patientMobilePhone' || itemName == 'patientPhoneNumber' || itemName == 'deliveryPhoneNumber') {
              target = target ? target.replace(/-/g, '') : target
              oldtarget = oldtarget ? oldtarget.replace(/-/g, '') : oldtarget
            // 住所の比較値成形&全体比較
            } else if (itemName == 'patientAddress' || itemName == 'patientHouseNumber' || itemName == 'patientBuilding') {
              let targetAdress = this.data.patientAdressAll
              let oldTargetAdress = this.data.previousRequestCpap['patientAddress'] + this.data.previousRequestCpap['patientHouseNumber'] + this.data.previousRequestCpap['patientBuilding']
              targetAdress = targetAdress ? targetAdress.replace(/ /g, '').replace(/　/g, '').replace(/\t/g, '').replace(/(\r)*\n/g, '').replace(/\r/g, '') : targetAdress
              oldTargetAdress = oldTargetAdress ? oldTargetAdress.replace(/ /g, '').replace(/　/g, '').replace(/\t/g, '').replace(/(\r)*\n/g, '').replace(/\r/g, '') : oldTargetAdress
              if (targetAdress == oldTargetAdress) {
                return false
              }
            // 機器納品先住所の比較値成形&全体比較
            } else if (itemName == 'deliveryAddress' || itemName == 'deliveryHouseNumber' || itemName == 'deliveryBuilding') {
              let targetAdress = this.data.deliveryAddressAll
              let oldTargetAdress = this.data.previousRequestCpap['deliveryAddress'] + this.data.previousRequestCpap['deliveryHouseNumber'] + this.data.previousRequestCpap['deliveryBuilding']
              targetAdress = targetAdress ? targetAdress.replace(/ /g, '').replace(/　/g, '').replace(/\t/g, '').replace(/(\r)*\n/g, '').replace(/\r/g, '') : targetAdress
              oldTargetAdress = oldTargetAdress ? oldTargetAdress.replace(/ /g, '').replace(/　/g, '').replace(/\t/g, '').replace(/(\r)*\n/g, '').replace(/\r/g, '') : oldTargetAdress
              if (targetAdress == oldTargetAdress) {
                return false
              }
            // 備考欄の比較値成形
            } else if (itemName == 'remarks') {
              target = target ? target.replace(/\n/g, '').replace(/ /g, '').replace(/　/g, '').replace(/\t/g, '').replace(/(\r)*\n/g, '').replace(/\r/g, '') : target
              oldtarget = oldtarget ? oldtarget.replace(/\n/g, '').replace(/ /g, '').replace(/　/g, '').replace(/\t/g, '').replace(/(\r)*\n/g, '').replace(/\r/g, '') : oldtarget
            // 機種・シリアル変更
            } else if (itemName == 'reportFormatType' || itemName == 'serial') {
              if (this.data.previousRequestCpap.reportFormatType && this.data.previousRequestCpap.reportFormatType != this.data.reportFormatType) {
                return true
              // 当該処方・ひとつの処方が内部指示書連携の場合
              } else if (this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence || this.data.previousRequestCpap.applicationType == this.cpapKindMap.applicationPhilipsCorrespondence) {
                if (this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence) {
                  if (!this.data[itemName]) {
                    return false
                  }
                }
                let beforeCorrespondReportFormatType = this.data.beforeCorrespondItems.reportFormatType
                let beforeCorrespondSerial = this.data.beforeCorrespondItems.serial
                // 機種変更・シリアル変更を確認
                if (beforeCorrespondReportFormatType != this.data.reportFormatType) {
                  if (!this.data.model) {
                    return false
                  } else {
                    return true
                  }
                } else if (itemName == 'serial' && beforeCorrespondSerial != this.data[itemName]) {
                  return true
                } else if (itemName == 'serial' && beforeCorrespondSerial == this.data[itemName]) {
                  return false
                } else if (itemName == 'reportFormatType' && beforeCorrespondReportFormatType == this.data[itemName]) {
                  return false
                }
              }
            }
            // NULL値と空値の比較を考慮
            if (!target && !oldtarget) {
              return false
            // 一つ前の処方と値を比較し変更がある場合はtrueを返却
            } else if (target != oldtarget) {
              return true;
            }
          }
        }
      }
      return false
    },
    changedPrescriptionCheck: function(displayOrder,displayName) {
      // QA358_変更ありマークの改修（JSON値の比較（本体））
      // 処方変更・転院再開・中止再開・内部指示書連携にのみ表示
      if (!this.isRequest) {
        if (this.data.kind == this.cpapKindMap.applicationChange || this.data.kind == this.cpapKindMap.applicationResume || this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence) {
          if (this.data.previousRequestCpap) {
            // 本体機種変更時は、機種、シリアル欄以外には変更ありラベルを表示しない
            if (this.data.previousRequestCpap.reportFormatType && this.data.previousRequestCpap.reportFormatType != this.data.reportFormatType) {
              return false
            // 当該処方・ひとつ前の処方が内部指示書連携の場合
            } else if (this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence || this.data.previousRequestCpap.applicationType == this.cpapKindMap.applicationPhilipsCorrespondence) {
              let beforeCorrespondReportFormatType = this.data.beforeCorrespondItems.reportFormatType
              // 機種変更を確認
              if (beforeCorrespondReportFormatType != this.data.reportFormatType) {
                return false
              }
            }
            // JSON値を比較
            let target = this.data.prescriptionItems.find(val => val.displayOrder == displayOrder)
            let oldTarget = this.data.previousRequestCpap.prescriptionContent.find(val => val.displayOrder == displayOrder)
            if (displayName == 'Flexタイプ') {
              let targetmode = this.data.prescriptionItems.find(val => val.displayName == 'モード')
              let oldTargetmode = this.data.previousRequestCpap.prescriptionContent.find(val => val.displayName == 'モード')
              if (targetmode && oldTargetmode) {
                if (targetmode != oldTargetmode) {
                  target = this.data.prescriptionItems.find(val => val.displayName == 'Flexタイプ' && val.mode.indexOf(Number(targetmode.value)) != -1)
                  oldTarget = this.data.previousRequestCpap.prescriptionContent.find(val => val.displayName == 'Flexタイプ' && val.mode.indexOf(Number(oldTargetmode.value)) != -1)
                }
              }
            }
            if (target && oldTarget) {
              if (target.value != oldTarget.value) {
                return true
              }
            }
          }
        }
      }
      return false
    },
    modulePrescriptionCheck: function(displayName) {
      // QA358_変更ありマークの改修（JSON値の比較（モデム））
      // 処方変更・転院再開・中止再開・内部指示書連携にのみ表示
      if (!this.isRequest) {
        if (this.data.kind == this.cpapKindMap.applicationChange || this.data.kind == this.cpapKindMap.applicationResume || this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence) {
          if (this.data.previousRequestCpap) {
            // 有無欄以外
            if (displayName != '通信モジュール') {
              // モデム機種変更時は、処方値欄には変更ありラベルを表示しない
              if (this.data.previousRequestCpap.moduleItemCode && this.data.previousRequestCpap.moduleItemCode != this.data.moduleItemCode) {
                return false
              // 当該処方・ひとつ前の処方が内部指示書連携の場合
              } else if (this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence || this.data.previousRequestCpap.applicationType == this.cpapKindMap.applicationPhilipsCorrespondence) {
                let beforeCorrespondModuleItemCode = this.data.beforeCorrespondItems.moduleItemCode
                // 機種変更・追加を確認
                if (beforeCorrespondModuleItemCode != this.data.moduleItemCode) {
                  return false
                }
              }
              // モデム無➡有の場合、処方値欄には変更ありマークを表示しない
              let targetmoduleUse = this.data.prescriptionItems.find(val => val.displayName == "通信モジュール")
              let oldModuleUse = this.data.previousRequestCpap.prescriptionContent.find(val => val.displayName == "通信モジュール")
              if (targetmoduleUse && oldModuleUse) {
                if (targetmoduleUse.value == 1 && oldModuleUse.value == 0) {
                  return false
                }
              } else if (targetmoduleUse && !oldModuleUse) {
                return false
              }
            // 有無欄
            } else {
              // 当該処方・ひとつ前の処方が内部指示書連携の場合
              if (this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence || this.data.previousRequestCpap.applicationType == this.cpapKindMap.applicationPhilipsCorrespondence) {
                let beforeCorrespondModuleItemCode = this.data.beforeCorrespondItems.moduleItemCode
                // 追加を確認
                if (beforeCorrespondModuleItemCode == "" && this.data.moduleItemCode) {
                  return true
                }
              }
            }
            // JSON値を比較
            let target = this.data.prescriptionItems.find(val => val.displayName == displayName)
            let oldTarget = this.data.previousRequestCpap.prescriptionContent.find(val => val.displayName == displayName)
            if (target && oldTarget) {
              if (target.value != oldTarget.value) {
                return true
              }
            // 前処方にモデムの各項目がなかったときに変更ありマークを表示する
            } else if (target && !oldTarget) {
              return true
            }
          }
        }
      }
      return false
    },
    moistPrescriptionCheck: function(displayName) {
      // QA358_変更ありマークの改修（JSON値の比較（加湿器））
      // 処方変更・転院再開・中止再開・内部指示書連携にのみ表示
      if (!this.isRequest) {
        if (this.data.kind == this.cpapKindMap.applicationChange || this.data.kind == this.cpapKindMap.applicationResume || this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence) {
          if (this.data.previousRequestCpap) {
            // 有無欄以外
            if (displayName != '加温加湿器') {
              // 加湿器機種変更時は、処方値欄には変更ありラベルを表示しない
              if (this.data.previousRequestCpap.moistItemCode && this.data.previousRequestCpap.moistItemCode != this.data.moistItemCode) {
                return false
              // 当該処方・ひとつ前の処方が内部指示書連携の場合
              } else if (this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence || this.data.previousRequestCpap.applicationType == this.cpapKindMap.applicationPhilipsCorrespondence) {
                let beforeCorrespondMoistItemCode = this.data.beforeCorrespondItems.moistItemCode
                // 機種変更・追加を確認
                if (beforeCorrespondMoistItemCode != this.data.moistItemCode) {
                  return false
                }
              }
              // 加湿器無➡有の場合、有無欄以外に変更ありマークを表示しない
              let targetmoistUse = this.data.prescriptionItems.find(val => val.displayName == "加温加湿器")
              let oldMoistUse = this.data.previousRequestCpap.prescriptionContent.find(val => val.displayName == "加温加湿器")
              if (targetmoistUse && oldMoistUse) {
                if (targetmoistUse.value == 1 && oldMoistUse.value == 0) {
                  return false
                }
              }
            // 有無欄
            } else {
              // 当該処方・ひとつ前の処方が内部指示書連携の場合
              if (this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence || this.data.previousRequestCpap.applicationType == this.cpapKindMap.applicationPhilipsCorrespondence) {
                let beforeCorrespondMoistItemCode = this.data.beforeCorrespondItems.moistItemCode
                // 追加を確認
                if (beforeCorrespondMoistItemCode == "" && this.data.moistItemCode) {
                  return true
                }
              }
            }
            // JSON値を比較
            let target = this.data.prescriptionItems.find(val => val.displayName == displayName)
            let oldTarget = this.data.previousRequestCpap.prescriptionContent.find(val => val.displayName == displayName)
            if (target && oldTarget) {
              if (target.value != oldTarget.value) {
                return true
              }
            // 前処方に加湿器の各項目がなかったときに変更ありマークを表示する
            } else if (target && !oldTarget) {
              return true
            }
          }
        }
      }
      return false
    },
    moduleMoistCheck: function(areaName,itemName) {
      // QA358_変更ありマークの改修（カラム値の比較（加湿器・モデム））
      // 処方変更・転院再開・中止再開・内部指示書連携にのみ表示
      if (!this.isRequest) {
        if (this.data.kind == this.cpapKindMap.applicationChange || this.data.kind == this.cpapKindMap.applicationResume || this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence) {
          if (this.data.previousRequestCpap) {
            let target = this.data[itemName]
            let oldtarget = this.data.previousRequestCpap[itemName]
            // 加湿器
            if (areaName == "moistArea") {
              // 加湿器追加の場合、機種、シリアル欄には変更ありラベルを表示しない
              let moistUse = this.data.prescriptionItems.find(val => val.displayName == "加温加湿器")
              let oldMoistUse = this.data.previousRequestCpap.prescriptionContent.find(val => val.displayName == "加温加湿器")
              if (moistUse && oldMoistUse) {
                if (moistUse.value == 1 && oldMoistUse.value == 0) {
                  return false
                }
              }
              // 当該処方・ひとつ前の処方が内部指示書連携の場合
              if (this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence || this.data.previousRequestCpap.applicationType == this.cpapKindMap.applicationPhilipsCorrespondence) {
                if (this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence) {
                  if (!this.data[itemName]) {
                    return false
                  }
                }
                let beforeCorrespondMoistItemCode = this.data.beforeCorrespondItems.moistItemCode
                let beforeCorrespondMoistSerial = this.data.beforeCorrespondItems.moistSerial
                if (beforeCorrespondMoistItemCode && this.data.moistItemCode) {
                  // 機種変更・シリアル変更を確認
                  if (beforeCorrespondMoistItemCode != this.data.moistItemCode) {
                    return true
                  } else if (itemName == 'moistSerial' && beforeCorrespondMoistSerial != this.data[itemName]) {
                    return true
                  } else if (itemName == 'moistSerial' && beforeCorrespondMoistSerial == this.data[itemName]) {
                    return false
                  } else if (itemName == 'moistItemCode' && beforeCorrespondMoistItemCode == this.data[itemName]) {
                    return false
                  }
                } else if (beforeCorrespondMoistItemCode == "" && this.data.moistItemCode) {
                  return false
                }
              }
            // モデム
            } else if (areaName == "moduleArea") {
              // モデム追加の場合、機種、シリアル欄には変更ありラベルを表示しない
              let moduleUse = this.data.prescriptionItems.find(val => val.displayName == "通信モジュール")
              let oldModuleUse = this.data.previousRequestCpap.prescriptionContent.find(val => val.displayName == "通信モジュール")
              if (moduleUse && oldModuleUse) {
                if (moduleUse.value == 1 && oldModuleUse.value == 0) {
                  return false
                }
              // 前処方の本体にモデムの概念がなかったときに変更ありマークを表示しない
              } else if (moduleUse && !oldModuleUse) {
                return false
              }
              // 当該処方・ひとつ前の処方が内部指示書連携の場合
              if (this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence || this.data.previousRequestCpap.applicationType == this.cpapKindMap.applicationPhilipsCorrespondence) {
                if (this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence) {
                  if (!this.data[itemName]) {
                    return false
                  }
                }
                let beforeCorrespondModuleItemCode = this.data.beforeCorrespondItems.moduleItemCode
                let beforeCorrespondModuleSerial = this.data.beforeCorrespondItems.moduleSerial
                if (beforeCorrespondModuleItemCode && this.data.moduleItemCode) {
                  // 機種変更・シリアル変更を確認
                  if (beforeCorrespondModuleItemCode != this.data.moduleItemCode) {
                    return true
                  } else if (itemName == 'moduleSerial' && beforeCorrespondModuleSerial != this.data[itemName]) {
                    return true
                  } else if (itemName == 'moduleSerial' && beforeCorrespondModuleSerial == this.data[itemName]) {
                    return false
                  } else if (itemName == 'moduleItemCode' && beforeCorrespondModuleItemCode == this.data[itemName]) {
                    return false
                  }
                } else if (beforeCorrespondModuleItemCode == "" && this.data.moduleItemCode) {
                  return false
                }
              }
            }
            // NULL値と空値の比較を考慮
            if (!target && !oldtarget) {
              return false
            // 一つ前の処方と値を比較し変更がある場合はtrueを返却
            } else if (target != oldtarget) {
              return true
            }
          }
        }
      }
      return false
    },
    getCpapChoicesList: async function() {
      this.departmentMaster = this.getCpapChoiceList(cpapChoicesType.departmentCode,false);
      this.customerCategory = this.getCpapChoiceList(cpapChoicesType.customerCategory,false);
      this.cancelCodeMaster = this.getCpapChoiceList(cpapChoicesType.cancellReason,false);
      this.billedCurrentMonth = this.getCpapChoiceList(cpapChoicesType.billedCurrentMonth,false);
    },
    changeDelivaryTarget: function(delivaryTarget) {
      // 支店回覧では申込み時の納品先情報を保持する
      if (this.cancelEdit && this.initialDeliveryTarget == delivaryTarget && this.initialDeliveryOther && this.data.deliveryOther) {
        this.data.deliveryPostcode = this.initialDeliveryPostcode
        this.data.deliveryAddress = this.initialDeliveryAddress
        this.data.deliveryHouseNumber = this.initialDeliveryHouseNumber
        this.data.deliveryBuilding = this.initialDeliveryBuilding
        this.data.deliveryDestination = this.initialDeliveryDestination
        this.data.deliveryPhoneNumber = this.initialDeliveryPhoneNumber
      } else {
        if (delivaryTarget == 0) {
          this.data.deliveryPostcode = this.data.patient.zip
          this.data.deliveryAddress = this.data.patient.address
          this.data.deliveryHouseNumber = this.data.patient.address1
          this.data.deliveryBuilding = this.data.patient.address2
          this.data.deliveryDestination = this.data.patient.patientFamilyName + " " + this.data.patient.patientFirstName
          if (this.data.patient.mobilePhone) {
            this.data.deliveryPhoneNumber = this.data.patient.mobilePhone
          } else {
            this.data.deliveryPhoneNumber = this.data.patient.phoneNumber
          }
        } else {
          this.data.deliveryPostcode = this.data.zip
          this.data.deliveryAddress = this.data.address
          this.data.deliveryHouseNumber = this.data.address1
          this.data.deliveryBuilding = this.data.address2
          this.data.deliveryDestination = this.data.receiverName
          this.data.deliveryPhoneNumber = this.data.phoneNumber
        }
      }
      this.isChangeDelivaryTarget = true;
    },
    /**
     * QA476 郵便番号からフォーカスが外れたら桁数に応じて桁数判定フラグを設定する
     * @param zipCode 郵便番号
     * @param flagName 桁数判定フラグ
     */
    onZipBlur(zipCode, flagName) {
      this[flagName] = zipCode.length < 7;
    },
    /**
     * QA476
     * @param refName フォーカスをあてる項目定義
     */
    focusMove(refName) {
      this.$nextTick(() => {
          const element = this.$refs[refName];
          if (element) {
            element.focus();
            const length = element.value.length;
            element.setSelectionRange(length, length);
          }
      })
    },
    onPaste() {
      this.isInitial = false;
      this.isChangeDelivaryTarget = false;
    }
  },
  data() {
    // 処方再開(転院)判定
    var resume = false;
    if(this.$route.params["resume"] || this.isResume){
      resume = true;
    }
    if (this.$route.params.results && this.$route.params.results.resume) {
      resume = true;
    }
    // 預託在庫からの申込み判定
    var isInstrument = false;
    if(this.$route.params["instrument"]){
      isInstrument = this.$route.params["instrument"];
    }
    if (this.$route.params.results && this.$route.params.results.depositUseFlag) {
      isInstrument = true;
    }
    let models = this.getCpapMaster();
    var kindList = this.getCpapKindList();
    var progressList = this.getCpapManagementStatusList();
    var branchOfficeMaster= this.getSalesOfficeMaster();
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = "";
    var userId = "";
    var isHospital = false;
    var isDealer = false;
    var isSalesOffice = false;
    var isHonsha = false;
    var isAdmin = false;
    if(userInfo){
      var roleId = userInfo.roleId;
      var userId = userInfo.id;
      var isHospital = roleId == role.role_hospital;
      var isDealer = roleId == role.role_dealer;
      var isSalesOffice = roleId == role.role_salesOffice;
      var isHonsha = roleId == role.role_headOffice;
      var isAdmin = roleId == role.role_admin;
    }
    var isMaster = true
    if(this.$props.isMasterAcquisition!=undefined){
      isMaster = this.$props.isMasterAcquisition
    }
    var isDeliveryInfoHidden = false
    if(this.$props.deliveryHidden!=undefined){
      isDeliveryInfoHidden = this.$props.deliveryHidden
    }
    // 預託は納品先情報を表示しない
    if (isInstrument) {
      isDeliveryInfoHidden = isInstrument;
    }
    var isRequest = false
    if(this.$props.requestFlg!=undefined){
      isRequest = this.$props.requestFlg
    }
    var officeCode = userInfo ? userInfo.salesOfficeCode : ""
    var directionsItemList = []
    if(this.$props.directionsItem && this.$props.directionsItem.length>0){
      directionsItemList = this.$props.directionsItem
    }
    var isViewer = false
    if(this.$props.viewerFlg!=undefined){
      isViewer = this.$props.viewerFlg
    }
    var cancelResume = false
    if (this.$props.cancelResume == true) {
      cancelResume = this.$props.cancelResume
    }
    // QA316 支店回覧では申込み時の納品先情報を保持する
    if (this.cancelEdit && this.data.deliveryOther) {
      this.initialDeliveryPostcode = this.data.deliveryPostcode
      this.initialDeliveryAddress = this.data.deliveryAddress
      this.initialDeliveryHouseNumber = this.data.deliveryHouseNumber
      this.initialDeliveryBuilding = this.data.deliveryBuilding
      this.initialDeliveryDestination = this.data.deliveryDestination
      this.initialDeliveryPhoneNumber = this.data.deliveryPhoneNumber
      this.initialDeliveryOther = this.data.deliveryOther
      this.initialDeliveryTarget = this.data.delivaryTarget == "home" ? 0 : 1
    }
    // QA457_転院の支店回覧で返却情報欄を引き継がない
    if ((this.kind == cpapKindMap.applicationChangeHospital || (this.kind == cpapKindMap.applicationCancel && !this.isTransferCancel)) && this.data.status == cpapRequestStatus.request && this.innerUser) {
      // 保存済であればスキップ
      if (!this.data.savedFlag) {
        this.data.billingCurrentMonth = ""
      }
    }
    // QA418 転院から処方中止の場合、契約終了日/中止理由/回収元/機器回収先(非表示)の値を指定する。
    if (this.isTransferCancel) {
      this.data.contractEndDate = this.data.confirmDate
      this.data.cancelReasonCode = "JF"
      this.data.collectionDestination = 0
      this.data.deliveryOther = false
      this.initialDeliveryOther = false
      // 機器回収先の住所を患者宅に設定
      this.data.returnSource = 0
      this.data.deliveryPostcode = this.data.patient.zip
      this.data.deliveryAddress = this.data.patient.address
      this.data.deliveryHouseNumber = this.data.patient.address1
      this.data.deliveryBuilding = this.data.patient.address2
      this.data.deliveryDestination = this.data.patient.patientFamilyName + " " + this.data.patient.patientFirstName
      if (this.data.patient.mobilePhone) {
        this.data.deliveryPhoneNumber = this.data.patient.mobilePhone
      } else {
        this.data.deliveryPhoneNumber = this.data.patient.phoneNumber
      }
    }
    return {
      role: role,
      roleId: roleId,
      userId: userId,
      isHospital: isHospital,
      isDealer: isDealer,
      isSalesOffice: isSalesOffice,
      isHonsha: isHonsha,
      isAdmin: isAdmin,
      extUserStatus: extUserStatus,
      models,
      cpapShippingMethodList:cpapShippingMethodList,
      cpapSenderMaster:cpapSenderMaster,
      cpapCodeMaster:[],
      progressList,
      kindList,
      departmentMaster:[],
      customerCategory:[],
      organizationModalActive: false,
      cancelCodeMaster:[],
      billedCurrentMonth:[],
      isMaster,
      cpapKindMap:cpapKindMap,
      officeCode,
      branchOfficeMaster,
      cpapDirectShippingList:cpapDirectShippingList,
      cpapLeaseUpList:cpapLeaseUpList,
      isDeliveryInfoHidden,
      isRequest,
      isInstrument,
      directionsItemList,
      resume,
      isViewer,
      searchTargetPostCode:"",
      searchTargetAddress: null,
      // 半角数字エラーメッセージ表示
      invalidPostcode: false,
      invalidPhoneNumber: false,
      // template message
      invalidNumberMessage,
      postcodePlaceholder,
      phonePlaceholder,
      cpapRequestStatus:cpapRequestStatus,
      digitErrorZipMessage,
      digitErrorDeliveryPostcode:false,
      isInitial:true,
      isChangeDelivaryTarget:false,
    };
  },
  components: {
    organizationSelectModal:OrganizationSelectModal
  },
  filters: {
    getNameFilter: function(val, list){
      var target = list.find(item => item.itemCodes && item.itemCodes.indexOf(val) != -1)
      if(target){
        return target.itemName
      }
      return ""
    },
    getSelectValueFilter: function(val, list){
      var target = list.find(item => item.key+"" == val+"")
      if(target){
        return target.value
      }
      return ""
    },
    getCalenderValueFilter: function(val){
      if(!val){
        return
      }
      return val.replace(/-/g,'/')
    },
    codeToValueFilter: function(val, list){
      var target = list.find(item => item.code+"" == val+"")
      if(target){
        return target.name
      }
      return ""
    },
    valueToTextFilter: function(val, list){
      var target = list.find(item => item.value+"" == val+"")
      if(target){
        return target.label
      }
      return ""
    },
    infectionFilter: function(val){
      switch(val){
        case "0":
          return "無し"
        case "1":
          return "MRSA"
        case "2":
          return "HCV"
        case "3":
          return "HBV"
        case "4":
          return "Wa"
        case "5":
          return "その他"
        default:
          return ""
      }
    },
  },
  mounted: async function() {
    if(this.isMaster && this.innerUser && !this.isRequest){
      // CPAP選択肢リスト取得
      await this.getCpapChoicesList();
    }
    // 転院は納品先情報を表示しない
    if ((this.kind == this.cpapKindMap.applicationResume || this.$route.params["kind"] == this.cpapKindMap.applicationResume) && !this.$route.params["cancelResume"] && !this.data.cancelResume) {
      this.isDeliveryInfoHidden = true;
    }
  },
  watch: {
    "data.deliveryPostcode"(newValue) {
      this.invalidPostcode = isNaN(Number(newValue));
      // QA476 郵便番号自動検索処理
      // 初期表示時、機器回収先が変更されたタイミングは郵便番号検索しない
      if (this.isInitial || this.isChangeDelivaryTarget) {
        this.isInitial = false;
        this.isChangeDelivaryTarget = false;
        return
      }
      // 申込み画面でこのモジュールの検索は実行しない
      if (!this.invalidPostcode && newValue.length === 7 && !this.isRequest) {
        this.addressSearch(newValue);
      }
    },
    "data.deliveryPhoneNumber"(newValue) {
      this.invalidPhoneNumber = isNaN(Number(newValue));
    }
  },
};
</script>
<style lang="scss" scoped>
#item-contens table.settings tr th {
  width: 300px;
}
#editMark{
  width:50px;
  vertical-align: middle;
}
.change::after {
  position: static;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/common/CpapRequestDetail.vue